import { gql } from "@apollo/client"

export const GET_ALL_ROLE_DOC_OPTIONS = gql`
  query Query($idReferential: String!) {
    getAllRoleDocOptions(idReferential: $idReferential)
  }
`
